import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { me, logout, type CurrentUser } from './api'
import { ApiError } from '@/lib/api/client'

const ME_KEY = ['auth', 'me'] as const

export function useCurrentUser() {
  return useQuery<CurrentUser, ApiError>({
    queryKey: ME_KEY,
    queryFn: me,
    staleTime: 60_000,
    retry: false,
  })
}

export function useLogout() {
  const navigate = useNavigate()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: logout,
    onSettled: () => {
      qc.clear()
      navigate('/login', { replace: true })
    },
  })
}
